import React, { Component } from 'react';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { withApollo } from 'react-apollo';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import withGraphqlData from '../shared/components/withGraphqlData';
import { parseFormErrors } from '../shared/utils/form_errors';
import RaffleForm from './components/RaffleForm';
import { GetRaffleQuery } from './queries';
import { UpdateRaffleMutation } from './queries';


class EditRaffle extends Component {
  handleSubmit = (data) => {
    const { client, objectId, push } = this.props;
    return client.mutate({ mutation: UpdateRaffleMutation, variables: { id: objectId, update: data } })
    .then(() => push('/raffles'))
    .catch(parseFormErrors);
  }

  render() {
    const { data } = this.props;

    return (
      <div>
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/raffles">Raffles</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Edit Raffle</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <RaffleForm
            initialValues={data.Raffle}
            onSubmit={this.handleSubmit}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  withProps(({ match }) => ({
    objectId: match.params.id,
  })),
  withGraphqlData(
    GetRaffleQuery,
    (props) => ({ id: props.objectId }),
    'no-cache',
  ),
  connect(null, { push }),
  withApollo,
)(EditRaffle);
